Vue.directive('matrixpopover', {

  unbind (el) {
    $(el).popover('dispose');
  },

  update (el, binding) {
    if (window.matchMedia('(min-width: 768px)').matches) {
      const popoveData = $(el).data('bs.popover');

      if (popoveData) {
        popoveData.setContent();
      }
    }
  },

  bind (el, binding) {
    if (window.matchMedia('(min-width: 768px)').matches) {
      setTimeout(() => {
        $(el).popover({
          sanitize: false,
          html: true,
          template: '<div class="popover matrix" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
          content: () => {
            return $(el).find('.tooltipContent').html();
          }
        });
      }, 1);
    }
  }
});
